import { StoryTranslationType } from "../../features/story.types";

export const story: StoryTranslationType = {
  success: {
    charactersSaved: "Personnages Sauvegardés",
    charactersAddedToLibrary: "Personnages Ajoutés à la Bibliothèque"
  },
  storySetup: {
    titles: {
      new: "Créer une Nouvelle Histoire",
      edit: "Modifier l'Histoire",
      continue: "Continuer l'Histoire"
    },
    basicInfo: {
      storyTitle: "Titre de l'Histoire",
      titlePlaceholder: "Entrez un titre captivant pour votre histoire",
      silverLining: "Description de l'Histoire",
      descriptionPlaceholder: "Décrivez brièvement le sujet de votre histoire",
      genre: "Genre",
      selectGenre: "Sélectionner un genre",
      environment: "Environnement",
      selectEnvironment: "Sélectionner un environnement",
      theme: "Thème",
      storyLength: "Longueur de l'Histoire",
      storyLengthWithNumberOfPages: "Longueur de l'Histoire (Nombre de Pages)",
      selectLength: "Sélectionner la longueur",
      aiSuggest: "Suggestion IA",
      missingValues: "Valeurs Manquantes",
      fillRequired: "Veuillez remplir tous les champs obligatoires",
      titleGenerated: "Titre Généré",
      generationError: "Erreur de Génération",
      tryAgain: "Réessayer",
      addCustomGenre: "Ajouter un Genre Personnalisé",
      addCustomEnvironment: "Ajouter un Environnement Personnalisé",
      addCustomTheme: "Ajouter un Thème Personnalisé",
      autoGenerate: "Générer Automatiquement",
      formDataGenerated: "Données du Formulaire Générées",
      dataUpdated: "Données Mise à Jour",
      formDataEnhanced: "Données du Formulaire Améliorées",
      noEnhancementsNeeded: "Aucune Amélioration Nécessaire",
      formDataUpToDate: "Les données du formulaire sont à jour",
      needSomeInfo: "Nous avons besoin de quelques informations pour commencer"
    },
    genres: {
      kidsStory: "Histoire pour Enfants",
      fantasy: "Fantaisie",
      romance: "Romance",
      adventure: "Aventure",
      contemporary: "Contemporain",
      historicalFiction: "Fiction Historique",
      scienceFiction: "Science-Fiction",
      mystery: "Mystère",
      horror: "Horreur",
      superhero: "Super-héros",
      thriller: "Thriller"
    },
    environments: {
      urbanCity: "Ville Urbaine",
      medievalCastle: "Château Médiéval",
      spaceStation: "Station Spatiale",
      forest: "Forêt",
      desert: "Désert",
      ocean: "Océan",
      mountain: "Montagne",
      smallTown: "Petite Ville",
      futuristicMetropolis: "Métropole Futuriste",
      underwaterKingdom: "Royaume Sous-marin",
      hauntedMansion: "Manoir Hanté",
      mountainCavern: "Caverne Montagneuse",
      dragonLair: "Repaire du Dragon",
      researchLaboratory: "Laboratoire de Recherche",
      futureCommunications: "Communications Futuristes",
      magicalLibrary: "Bibliothèque Magique",
      rainyNight: "Nuit Pluvieuse",
      ancientTemple: "Temple Ancien"
    },
    storyLengths: {
      short: "Courte",
      medium: "Moyenne",
      long: "Longue",
      natural: "Naturelle"
    },
    characters: {
      name: "Nom du Personnage",
      description: "Description du Personnage",
      title: "Personnages",
      browseCharacters: "Parcourir les Personnages",
      makePublic: "Rendre le personnage public"
    },
    character: {
      name: "Nom du Personnage",
      namePlaceholder: "Entrez le nom du personnage",
      role: "Rôle du Personnage",
      selectRole: "Sélectionnez le rôle du personnage",
      description: "Description du Personnage",
      descriptionPlaceholder: "Entrez la description du personnage",
      create: "Créer le Personnage",
      update: "Mettre à Jour le Personnage",
      roles: {
        protagonist: "Protagoniste",
        antagonist: "Antagoniste",
        deuteragonist: "Deutéragoniste",
        mentor: "Mentor",
        comic_relief: "Personnage Comique",
        mysterious: "Figure Mystérieuse",
        love_interest: "Intérêt Amoureux",
        anti_hero: "Anti-héros",
        sidekick: "Acolyte",
        shapeshifter: "Métamorphe",
        guardian: "Gardien",
        catalyst: "Catalyseur"
      }
    },
    themeSection: {
      title: "Thèmes"
    },
    themeOptions: {
      friendship: "Amitié",
      love: "Amour",
      betrayal: "Trahison",
      redemption: "Rédemption",
      growth: "Croissance",
      power: "Pouvoir",
      justice: "Justice",
      family: "Famille",
      courageBravery: "Courage & Bravoure",
      magicMythology: "Magie & Mythologie",
      survival: "Survie",
      warConflict: "Guerre & Conflit",
      freedomRebellion: "Liberté & Rébellion",
      violenceRevenge: "Violence & Vengeance",
      passionEroticism: "Passion & Érotisme",
      quest: "Quête",
      ancientWisdom: "Sagesse Ancienne",
      timeTravel: "Voyage dans le Temps",
      technology: "Technologie",
      paradox: "Paradoxe",
      knowledge: "Connaissance",
      magic: "Magie",
      discovery: "Découverte",
      identity: "Identité",
      sacrifice: "Sacrifice",
      transformation: "Transformation"
    },
    buttons: {
      create: "Créer l'Histoire",
      update: "Mettre à Jour l'Histoire"
    },
    success: {
      title: "Configuration de l'Histoire Terminée",
      description: "Votre histoire a été créée avec succès et est prête pour votre voyage créatif."
    },
    failure: {
      title: "Échec de la Configuration de l'Histoire",
      description: "Une erreur inattendue s'est produite lors de la création de l'histoire. Veuillez réessayer.",
    },
  },
  story: {
    parts: "Parties",
    part: "Partie",
    continueStory: "Continuer l'Histoire",
    print: "Imprimer",
    generatingSummary: "Génération du Résumé",
    generatingContinuation: "Génération de la Suite",
    pleaseWait: "Veuillez patienter...",
    backToDashboard: "Retour au Tableau de Bord",
    extractCharacters: "Extraire les Personnages",
    foundCharacters: "Personnages Trouvés",
    addSelectedCharacters: "Ajouter les Personnages Sélectionnés",
    share: "Partager",
    viewEntire: "Voir l'Histoire Complète",
    viewPaginated: "Voir en Pages",
    tooltips: {
      upgradeToContinue: "Passez à la version supérieure pour continuer les histoires",
      upgradeToShare: "Passez à la version supérieure pour partager les histoires",
      upgradeToExtract: "Passez à la version supérieure pour extraire les personnages"
    },
    ratings: {
      submitted: "Évaluation soumise",
      thankYou: "Merci d'avoir évalué cette histoire !",
      error: "Erreur",
      failedToSubmit: "Échec de l'envoi de l'évaluation"
    },
    sharing: {
      dialogTitle: "Partager votre histoire",
      dialogDescription: "Choisissez où vous souhaitez partager votre histoire",
      privacy: "Confidentialité de l'Histoire",
      privacyLevels: {
        private: "Privée",
        public: "Publique",
        friends: "Amis Uniquement"
      },
      platform: "Plateforme",
      selectPlatform: "Sélectionner une plateforme",
      customMessage: "Message Personnalisé",
      customMessagePlaceholder: "Ajoutez un message à votre partage...",
      shareButton: "Partager l'Histoire",
      successTitle: "Histoire partagée avec succès",
      successMessage: "Votre histoire a été partagée sur {{platform}}",
      authRequired: "Authentification requise",
      authMessage: "Veuillez vous connecter pour partager des histoires."
    },
    upgrade: {
      title: "Mise à Niveau Requise",
      continueDescription: "Mettez à niveau votre compte pour créer des séquences d'histoire.",
      continueFeature: "Créez des séquences d'histoire avec un abonnement premium",
      shareDescription: "Mettez à niveau votre compte pour partager des histoires.",
      shareFeature: "Partagez des histoires avec un abonnement basique",
      extractDescription: "Mettez à niveau votre compte pour extraire des personnages.",
      extractFeature: "Extrayez des personnages avec un abonnement premium",
      upgradeButton: "Mettre à Niveau Maintenant"
    }
  },
  storyEditor: {
    navigation: {
      previousPage: "Page Précédente",
      continue: "Continuer",
      returnToDashboard: "Retour au Tableau de Bord",
      page: "Page",
      of: "de",
      remainingPages: "Pages Restantes",
    },
    input: {
      customResponse: "Réponse Personnalisée"
    },
    choices: {
      yourChoice: "Votre Choix"
    },
    completedStory: {
      title: "Votre Histoire est Terminée",
      description: "Votre histoire a atteint sa conclusion !",
    },
  },  
  imageGeneration:{
    ready: "Prêt",
    imageReady: "Image Prête",
    insufficientCredits: "Crédits Insuffisants",
    needMoreCredits: "Besoin de Plus de Crédits",
    failed: "Échec",
    processing: "Traitement",
    pleaseWait: "Veuillez patienter",
    unexpectedError: "Erreur Inattendue",
    generateImage: "Générer une Image",
    costsCredits: "Coûte des Crédits",
    generatingImage: "Génération de l'Image",
    credits: "crédits",
    creditsLabel: "crédits",
    selectImage: "Sélectionner une Image",
    selectImageDescription: "Sélectionnez une image pour votre histoire",
    selectPreferred: "Sélectionner l'Image Préférée",
    contentNotFound: "Contenu Non Trouvé",
    saved: "Image Sauvegardée",
    imageSaved: "Image Sauvegardée",
    partialSuccess: "Succès Partiel",
    someImagesFailed: "Certaines images n'ont pas pu être générées",
  },
  audioGeneration: {
    insufficientCredits: "Crédits Insuffisants",
    generateAudio: "Générer de l'Audio",
    generatingAudio: "Création de l'Audio",
    pleaseWait: "Veuillez patienter",
    failed: "Échec",
    success: "Succès",
    audioReady: "Audio Prêt",
    audioAvailable: "Audio Disponible"
  },
  storyRewrite:{
    rewritesLeft: "Réécritures Restantes",
    rewriteStory: "Réécrire l'Histoire",
    rewriteComplete: "Réécriture de l'Histoire Complétée",
    refreshingContent: "Actualisation du Contenu",
    refreshError: "Erreur d'Actualisation",
    refreshErrorMessage: "Une erreur inattendue s'est produite lors de l'actualisation de l'histoire. Veuillez réessayer.",
    noRewritesLeft: "Aucune réécriture restante",
    tryPageRefresh: "Essayez de rafraîchir la page",
  },
  loadingMessages: {
    craftingTheNextChapter: "Création du Prochain Chapitre",
    weavingThePlotTwists: "Entrelaçant les Rebonds de l'Histoire",
    yourAdventureIsAboutToUnfold: "Votre Aventure est sur le Point de se Dévoiler",
    developingTheCharacters: "Développement des Personnages",
    imaginingNewPossibilities: "Imaginant de Nouvelles Possibilités",
  },
};
